"use client";

var __jsx = React.createElement;
import React, { useEffect } from "react";
import Header from "./components/header";
import Footer from "./components/footer";
import { useCustomer } from "@lib/context/shared/customer-context";
import HubSpotScript from "@modules/shared/components/hub-spot-script";
import UtilityModal from "@modules/shared/components/utility-modal";
import useAuthModals from "@lib/hooks/use-auth-modals";
import Cookies from "js-cookie";
import { usePathname } from "next/navigation";
import useWowOfferTranslations from "@lib/hooks/use-wow-offer-translations";
import useMuscleRouter from "@lib/hooks/use-muscle-router";
import { useIsLoadingResources } from "@lib/context/shared/loading-resources-context";
import { cn } from "@lib/cn";
const draft = process.env.NEXT_PUBLIC_STORYBLOK_ON_DRAFT === "true";
const MODAL_IMAGE_ROUTES = {
  logo: "muscle_storefront/financial_entity/branding/platform_logo".concat(draft ? "_test" : ""),
  entityLogo: "muscle_storefront/financial_entity/branding/entity_points_logo_contrast".concat(draft ? "_test" : ""),
  contentImage: "muscle_storefront/financial_entity/images/utility_image"
};
const MusclePlatformLayout = _ref => {
  let {
    children,
    headerProps,
    showCustomerSupport
  } = _ref;
  const {
    customerIsLogged,
    setShowUtilityModal,
    showUtilityModal,
    isLoadingCustomer
  } = useCustomer();
  const {
    isLoadingPage
  } = useIsLoadingResources();
  const {
    registerFunction
  } = useAuthModals();
  const currentApp = localStorage.getItem("current-app");
  const pathname = usePathname();
  const validHomePaths = ['', '/es', '/en'].map(locale => "".concat(locale, "/").concat(currentApp));
  const isHomePage = validHomePaths.includes(pathname || '');
  const isUtilityModalEnabled = process.env.NEXT_PUBLIC_SHOW_UTILITY_MODAL === "true";
  const isMillasBenefit = pathname.includes('millasbenefit');
  const shouldShowModal = isUtilityModalEnabled && showUtilityModal && !customerIsLogged && !isMillasBenefit;
  const {
    isAllActive,
    isAnyActive,
    isHotelActive,
    isFlightActive,
    isCarActive
  } = useWowOfferTranslations();
  const router = useMuscleRouter();
  useEffect(() => {
    const hasSeenModal = Cookies.get("utility-modal-shown");
    if (!hasSeenModal && isUtilityModalEnabled && validHomePaths.includes(pathname)) {
      setShowUtilityModal(true);
    }
    return () => {
      Cookies.remove("utility-modal-shown");
    };
  }, [customerIsLogged]);
  const handleCloseModal = () => {
    setShowUtilityModal(false);
    Cookies.set("utility-modal-shown", "true", {
      expires: undefined
    });
  };
  const handleRedirect = () => {
    if (isAllActive || !isAnyActive) {
      registerFunction();
      handleCloseModal();
    }
    if (isHotelActive) {
      router.push("/hotels");
      handleCloseModal();
    }
  };
  return __jsx(React.Fragment, null, __jsx(Header, headerProps), __jsx("div", {
    className: cn(isLoadingPage && "h-full")
  }, children), __jsx(Footer, null), __jsx(HubSpotScript, {
    show: customerIsLogged && showCustomerSupport
  }), __jsx(UtilityModal, {
    open: shouldShowModal && !isLoadingCustomer,
    onClose: handleCloseModal,
    urlActionFunction: handleRedirect,
    imageRoutes: MODAL_IMAGE_ROUTES,
    linkedWords: ["aquí", "here"]
  }));
};
export default MusclePlatformLayout;